import TwoFactorContainer from "../../../../../Components/Forms&Table/Forms/FormLayout/TwoFactor/TwoFactorContainer";

const TwoFactor = () => {
  return <TwoFactorContainer />;
};

export default TwoFactor;
